export const FILE_LIST_SORT_FIELDS = {
  IMPORT: 'import',
  DATETIME: 'dateTaken',
  FILENAME: 'filename',
  FILESIZE: 'size',
};

export const FILE_LIST_SORT_OPTIONS = [
  { id: FILE_LIST_SORT_FIELDS.IMPORT, label: 'Import order' },
  { id: FILE_LIST_SORT_FIELDS.DATETIME, label: 'Datetime' },
  { id: FILE_LIST_SORT_FIELDS.FILENAME, label: 'Filename' },
  { id: FILE_LIST_SORT_FIELDS.FILESIZE, label: 'Filesize' },
];

export const FILE_LIST_FILTER_OPTIONS = {
  dateStatuses: [
    { id: 'with-date', label: 'With Date' },
    { id: 'missing-date', label: 'Missing Date' },
    { id: 'invalid-date', label: 'Invalid Date' },
  ],
  gpsStatuses: [
    { id: 'with-gps', label: 'With GPS' },
    { id: 'missing-gps', label: 'Missing GPS' },
  ],
  editStatuses: [
    { id: 'edited', label: 'Edited' },
    { id: 'unedited', label: 'Unedited' },
  ],
};

const SORT_FIELDS_SET = new Set(FILE_LIST_SORT_OPTIONS.map((option) => option.id));
const DATE_FILTER_SET = new Set(FILE_LIST_FILTER_OPTIONS.dateStatuses.map((option) => option.id));
const GPS_FILTER_SET = new Set(FILE_LIST_FILTER_OPTIONS.gpsStatuses.map((option) => option.id));
const EDIT_FILTER_SET = new Set(FILE_LIST_FILTER_OPTIONS.editStatuses.map((option) => option.id));

export function createDefaultFileListSort() {
  return {
    field: FILE_LIST_SORT_FIELDS.IMPORT,
    direction: 'asc',
  };
}

export function createDefaultFileListFilters() {
  return {
    dateStatuses: [],
    gpsStatuses: [],
    editStatuses: [],
  };
}

export function normalizeFileListSort(sort) {
  const defaults = createDefaultFileListSort();
  if (!sort || typeof sort !== 'object') return defaults;

  const field = SORT_FIELDS_SET.has(sort.field) ? sort.field : defaults.field;
  const direction = sort.direction === 'desc' ? 'desc' : 'asc';

  return { field, direction };
}

function normalizeFilterArray(values, allowedSet) {
  if (!Array.isArray(values)) return [];
  return Array.from(new Set(values.filter((value) => allowedSet.has(value))));
}

export function normalizeFileListFilters(filters) {
  const defaults = createDefaultFileListFilters();
  if (!filters || typeof filters !== 'object') return defaults;

  return {
    dateStatuses: normalizeFilterArray(filters.dateStatuses, DATE_FILTER_SET),
    gpsStatuses: normalizeFilterArray(filters.gpsStatuses, GPS_FILTER_SET),
    editStatuses: normalizeFilterArray(filters.editStatuses, EDIT_FILTER_SET),
  };
}

export function countActiveFileListFilters(filters) {
  const normalized = normalizeFileListFilters(filters);
  return (
    normalized.dateStatuses.length +
    normalized.gpsStatuses.length +
    normalized.editStatuses.length
  );
}
